<div #container class="split-container-vertical" [class.collapsed-top]="showCollapsedTop" [class.collapsed-bottom]="showCollapsedBottom">
  <div class="top-pane" [style.flex-basis.%]="topRatio * 100">
    <ng-content select="[top]"></ng-content>
  </div>
  <div #divider class="divider-horizontal" role="separator" aria-orientation="horizontal" tabindex="0" (mousedown)="onDividerMouseDown($event)"></div>
  <div class="bottom-pane" [style.flex-basis.%]="(100 - topRatio * 100)">
    <ng-content select="[bottom]"></ng-content>
  </div>

  @if (showCollapsedTop) {
    <div class="restore-hover-zone top" aria-hidden="true"></div>
  }
  @if (showCollapsedTop) {
    <button type="button" class="restore-pill top" aria-label="Restore top" (click)="restoreFromTop()">
      <i class="bi bi-chevron-down"></i>
    </button>
  }
  @if (showCollapsedBottom) {
    <div class="restore-hover-zone bottom" aria-hidden="true"></div>
  }
  @if (showCollapsedBottom) {
    <button type="button" class="restore-pill bottom" aria-label="Restore bottom" (click)="restoreFromBottom()">
      <i class="bi bi-chevron-up"></i>
    </button>
  }
</div>


